import { api } from "./configs/axiosConfigs"

export const BussinesAreaAPI = {
    
    getBussinesArea: async (data:any) => {
        const response = await api.get(
            '/businessarea', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    getBussinesAreaByCompany: async (data:any) => {
        const response = await api.get(
            '/businessarea', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    createBussinesArea: async (data: any) => {
        const response = await api.post(
            '/businessarea/register', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },
    
    editBussinesArea: async (idstore: number, data: any) => {
        const response = await api.patch(
            `/businessarea/${idstore}`, data
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    changeStatusBusinessArea: async (idstore: number, data: any) => {
        const response = await api.patch(
            `/businessarea/changeStatus/${idstore}`, data
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
    
    deleteBussinesArea: async (idstore: number) => {
        const response = await api.delete(
            `/businessarea/${idstore}`
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
}